import React, { useState } from "react";
import { Dna } from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import "../../css/main.css";
import { getChangeProfile } from "../../redux/action";
function ChangeProfile() {
  const [Profileing, setProfileing] = useState([]);
  const dispatch = useDispatch();
  const { data, loading, error } = useSelector((state) => state.ChangeProfile);
  ///////////////////////////////////////////////////////////////////////
  function req() {
    if (
      Profileing.FirstName &&
      Profileing.LastName &&
      Profileing.Gender &&
      Profileing.Age &&
      Profileing.City
    ) {
      dispatch(getChangeProfile(Profileing));
      setTimeout(() => {
        if (data) {
          toast.success("Profile edit successfully registered", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        } else if (error) {
          toast.error(error, {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
      }, 1000);
    } else {
      toast.error("Complete the information", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  }

  return (
    <div className="w-full">
      <ToastContainer />
      {loading ? (
        <div className="mt-32 flex justify-center">
          <Dna
            visible={true}
            height="150"
            width="150"
            ariaLabel="dna-loading"
            wrapperStyle={{}}
            wrapperClass="dna-wrapper"
          />
        </div>
      ) : error ? (
        <div className="flex justify-center">
          <div className="alert alert-error shadow-lg w-8/12 mt-20">
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="stroke-current flex-shrink-0 h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <span>Error! Task failed successfully.</span>
            </div>
          </div>
        </div>
      ) : (
        <div className="sm:flex -ml-96 w-80 sm:w-80 sm:-ml-56 md:w-80 md:-ml-12 lg:w-10/12 lg:ml-5 xl:w-7/12 xl:ml-32 2xl:w-4/12 2xl:ml-96">
          <div className="card w-full bg-primary text-primary-content mt-72 sm:mt-32 shadow-lg">
            <div className="card-body text-black dark:text-slate-100">
              <input
                type="text"
                id="FirstName"
                placeholder="First Name"
                className="input input-bordered input-primary w-full text-center mb-5"
                onChange={(e) =>
                  setProfileing((last) => {
                    const help = JSON.parse(JSON.stringify(last));
                    help.FirstName = e.target.value;
                    return { ...help };
                  })
                }
              />
              <input
                type="text"
                id="LastName"
                placeholder="Last Name"
                className="input input-bordered input-primary w-full text-center mb-5"
                onChange={(e) =>
                  setProfileing((last) => {
                    const help = JSON.parse(JSON.stringify(last));
                    help.LastName = e.target.value;
                    return { ...help };
                  })
                }
              />
              <span
                id="Gender"
                className="input input-primary w-full text-center mb-5 flex"
              >
                <div className="form-control inline-block w-full">
                  <label className="label cursor-pointer inline-flex mr-10 w-20">
                    <span className="label-text text-base mr-2">female</span>
                    <input
                      type="radio"
                      value="female"
                      name="radio-2"
                      className="radio radio-primary"
                      onChange={(e) =>
                        setProfileing((last) => {
                          const help = JSON.parse(JSON.stringify(last));
                          help.Gender = e.target.value;
                          return { ...help };
                        })
                      }
                    />
                  </label>
                  <label className="label cursor-pointer inline-flex w-20">
                    <span className="label-text text-base mr-2">male</span>
                    <input
                      type="radio"
                      value="male"
                      name="radio-2"
                      className="radio radio-primary"
                      onChange={(e) =>
                        setProfileing((last) => {
                          const help = JSON.parse(JSON.stringify(last));
                          help.Gender = e.target.value;
                          return { ...help };
                        })
                      }
                    />
                  </label>
                </div>
              </span>

              <input
                type="text"
                id="Age"
                placeholder="Age"
                className="input input-bordered input-primary w-full text-center mb-5"
                onChange={(e) =>
                  setProfileing((last) => {
                    const help = JSON.parse(JSON.stringify(last));
                    help.Age = e.target.value;
                    return { ...help };
                  })
                }
              />
              <input
                type="text"
                id="City"
                placeholder="City"
                className="input input-bordered input-primary w-full text-center mb-5"
                onChange={(e) =>
                  setProfileing((last) => {
                    const help = JSON.parse(JSON.stringify(last));
                    help.City = e.target.value;
                    return { ...help };
                  })
                }
              />
              <div className="card-actions justify-evenly mt-5">
                <button
                  className="btn sm:w-5/12 lg:w-4/12"
                  onClick={() => req()}
                >
                  done
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ChangeProfile;
